import React, { useContext } from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';
import OrganizationDropdown from '../../../components/Header/OrganizationDropdown';
import AuthContext from '../../../contexts/authContext';
import { UserType } from '../../../common/data/dummyRolesData';

const SimpleHeader = () => {
	const { userData } = useContext(AuthContext);
	const isCompany = userData?.role === UserType.COMPANY;

	return (
		<Header>
			<HeaderLeft>
				<div className='ms-2'>{/* Logo or other content can go here */}</div>
			</HeaderLeft>

			{/* Center organization dropdown for company users only */}
			{isCompany && (
				<div
					className='d-flex justify-content-start align-items-center'
					style={{ flex: '1' }}>
					<div className='bg-l10-primary rounded px-3 py-1'>
						<OrganizationDropdown />
					</div>
				</div>
			)}

			<CommonHeaderRight />
		</Header>
	);
};

export default SimpleHeader;
